import _implicitStylesheets from "./pdfViewer.css";

import _implicitScopedStylesheets from "./pdfViewer.scoped.css?scoped=true";

import _lightningButtonIcon from "lightning/buttonIcon";
import _zpaperPdfViewerThumbnails from "zpaper/pdfViewerThumbnails";
import _zpaperPdfViewerToolbar from "zpaper/pdfViewerToolbar";
import _zpaperPdfViewerMainPane from "zpaper/pdfViewerMainPane";
import {registerTemplate} from "lwc";
function tmpl($api, $cmp, $slotset, $ctx) {
  const {b: api_bind, c: api_custom_element, h: api_element, t: api_text} = $api;
  const {_m0, _m1, _m2, _m3, _m4, _m5} = $ctx;
  return [api_element("div", {
    classMap: {
      "pdfViewerContainer": true
    },
    key: 0
  }, [!$cmp.renderMobileToolbar ? api_element("div", {
    classMap: {
      "sidebarPanel": true
    },
    key: 1
  }, [api_element("div", {
    classMap: {
      "buttonsPanel": true
    },
    key: 2
  }, [api_element("div", {
    classMap: {
      "toolbarButton": true
    },
    key: 3
  }, [$cmp.displayToolbar ? api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    props: {
      "iconName": "utility:settings",
      "variant": "bare",
      "size": "large"
    },
    key: 4,
    on: {
      "click": _m0 || ($ctx._m0 = api_bind($cmp.toggleToolbar))
    }
  }, []) : null]), api_element("div", {
    classMap: {
      "toolbarButton": true
    },
    key: 5
  }, [api_element("span", {
    classMap: {
      "smallquestion": true,
      "tooltip": true,
      "helpdoc": true
    },
    attrs: {
      "data-id": "exampleHelp"
    },
    key: 6,
    on: {
      "click": _m1 || ($ctx._m1 = api_bind($cmp.openDefaultContent))
    }
  }, [api_element("span", {
    classMap: {
      "smallQIcon": true
    },
    key: 7
  }, [api_text("?")])])]), $cmp.renderThumbnails ? api_element("div", {
    classMap: {
      "thumbnailsButton": true
    },
    key: 8
  }, [api_custom_element("lightning-button-icon", _lightningButtonIcon, {
    props: {
      "iconName": "utility:side_list",
      "variant": "bare",
      "size": "large"
    },
    key: 9,
    on: {
      "click": _m2 || ($ctx._m2 = api_bind($cmp.handleToggleThumbnails))
    }
  }, [])]) : null]), $cmp.renderThumbnails ? api_element("div", {
    className: $cmp.panelClasses,
    key: 10
  }, [api_element("div", {
    classMap: {
      "slds-panel__body": true,
      "slds-align_absolute-center": true
    },
    styleDecls: [["padding", "0rem", false]],
    key: 11
  }, [api_custom_element("zpaper-pdf-viewer-thumbnails", _zpaperPdfViewerThumbnails, {
    classMap: {
      "thumbnails-pane": true,
      "floatRight": true
    },
    props: {
      "snippetId": $cmp.snippetId,
      "parentLoadsPdf": $cmp.parentLoadsPdf,
      "multiSelect": "true"
    },
    key: 12,
    on: {
      "thumbnailclick": _m3 || ($ctx._m3 = api_bind($cmp.changePage))
    }
  }, [])])]) : null]) : null, $cmp.renderMobileToolbar ? api_element("div", {
    className: $cmp.panelClasses,
    key: 13
  }, [api_element("div", {
    classMap: {
      "slds-panel__body": true,
      "slds-align_absolute-center": true
    },
    styleDecls: [["padding", "0rem", false]],
    key: 14
  }, [api_custom_element("zpaper-pdf-viewer-thumbnails", _zpaperPdfViewerThumbnails, {
    classMap: {
      "thumbnails-pane": true,
      "floatRight": true
    },
    props: {
      "snippetId": $cmp.snippetId,
      "parentLoadsPdf": $cmp.parentLoadsPdf,
      "multiSelect": "true"
    },
    key: 15,
    on: {
      "thumbnailclick": _m4 || ($ctx._m4 = api_bind($cmp.changePage))
    }
  }, [])])]) : null, api_element("div", {
    classMap: {
      "mainContent": true
    },
    key: 16
  }, [!$cmp.renderMobileToolbar ? $cmp.displayToolbar ? api_element("div", {
    className: $cmp.toolbarClasses,
    key: 17
  }, [api_custom_element("zpaper-pdf-viewer-toolbar", _zpaperPdfViewerToolbar, {
    key: 18
  }, [])]) : null : null, api_element("div", {
    classMap: {
      "mainPane": true
    },
    key: 19
  }, [api_element("div", {
    classMap: {
      "default-content": true,
      "display-none": true
    },
    key: 20,
    on: {
      "click": _m5 || ($ctx._m5 = api_bind($cmp.closeDefaultContent))
    }
  }, [!$cmp.isMobile ? api_element("iframe", {
    classMap: {
      "modal-content": true
    },
    attrs: {
      "src": "https://qr.md/red/sprkz-help/",
      "frameborder": "0"
    },
    key: 21
  }, []) : null, $cmp.isMobile ? api_element("iframe", {
    classMap: {
      "modal-content": true
    },
    attrs: {
      "src": "https://qr.md/red/sprkz-mobile-help/",
      "frameborder": "0"
    },
    key: 22
  }, []) : null, api_element("div", {
    classMap: {
      "caption": true
    },
    key: 23
  }, [api_text("Document will display here.")])]), api_custom_element("zpaper-pdf-viewer-main-pane", _zpaperPdfViewerMainPane, {
    classMap: {
      "pdfViewerMainPane": true
    },
    props: {
      "parentLoadsPdf": $cmp.parentLoadsPdf
    },
    key: 24
  }, [])])])])];
}
export default registerTemplate(tmpl);
tmpl.stylesheets = [];


if (_implicitStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitStylesheets)
}
if (_implicitScopedStylesheets) {
  tmpl.stylesheets.push.apply(tmpl.stylesheets, _implicitScopedStylesheets)
}
tmpl.stylesheetToken = "zpaper-pdfViewer_pdfViewer"
